class SliderUpsell extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector(".swiper");
    this.quantitySelectors = this.querySelectorAll("quantity-input");
    this.productForms = this.querySelectorAll("product-form form");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.originalHTML = this.innerHTML;

    if (typeof Swiper !== "undefined" && typeof subscribe !== "undefined")
      this.init();

    document.addEventListener("DOMContentLoaded", this.init.bind(this));

    this.quantitySelectors.forEach((qs) => {
      qs.addEventListener("change", this.onQuantityChange.bind(this));
    });
  }

  onQuantityChange(event) {
    this.slider.classList.add("loading");

    const quantitySelector = event.target.closest("quantity-input");
    const quantityInput = quantitySelector.querySelector("input");

    fetch(
      window.Shopify.routes.root +
      "cart/change.js?sections=" +
      this.cart
        .getSectionsToRender()
        .map((section) => section.id)
        .join(","),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: quantitySelector.dataset.variantId,
          quantity: parseInt(event.target.value),
        }),
      }
    )
      .then((r) => r.json())
      .then((response) => {
        const item = response.items.find(
          (i) => i.variant_id === quantitySelector.dataset.variantId
        );

        if (item) {
          quantityInput.value = item.quantity;
          this.slider.classList.remove("loading");
        } else {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "slider-upsell" });
        }

        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
        this.slider.classList.remove("loading");
      });
  }

  onCartUpdate() {
    if (!this.slider) return;

    this.slider.classList.add("loading");

    fetch(`/?section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const update = html.querySelector(
          `.slider-upsell[data-block-id="${this.dataset.blockId}"]`
        );

        if (!update) return;

        const newSlider = document.createElement('slider-upsell');
        newSlider.dataset.sectionId = update.dataset.sectionId;
        newSlider.dataset.blockId = update.dataset.blockId;
        newSlider.className = update.className;
        newSlider.innerHTML = update.innerHTML;
        this.replaceWith(newSlider);

        // Re-init: constructor ran when element was empty, so slider/selectors were null
        newSlider.slider = newSlider.querySelector(".swiper");
        newSlider.quantitySelectors = newSlider.querySelectorAll("quantity-input");
        newSlider.quantitySelectors.forEach((qs) => {
          qs.addEventListener("change", newSlider.onQuantityChange.bind(newSlider));
        });
        if (newSlider.slider && typeof Swiper !== "undefined") {
          newSlider.init();
        }
        newSlider.querySelectorAll("product-form").forEach((form) => {
          document.dispatchEvent(new CustomEvent("product:form:mount", { detail: { form } }));
        });
        if (typeof window.theme !== "undefined" && typeof window.theme.initProductForms === "function") {
          window.theme.initProductForms();
        }
        bindAddonSwatchClicks();

        // Force images to load: lazy-loaded images may not load when inserted dynamically
        newSlider.querySelectorAll("img").forEach((img) => {
          img.loading = "eager";
          if (img.dataset.src || img.getAttribute("data-src")) {
            const src = img.dataset.src || img.getAttribute("data-src");
            if (src) img.src = src;
          }
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.slider.classList.remove("loading");
      });
  }

  mergeCartStatesWithOriginal(updatedElement) {
    const updatedSlides = updatedElement.querySelectorAll('.swiper-slide');
    const currentSlides = this.querySelectorAll('.swiper-slide');

    updatedSlides.forEach((updatedSlide, index) => {
      const currentSlide = currentSlides[index];
      if (!currentSlide) return;

      const updatedQuantityInput = updatedSlide.querySelector('quantity-input');
      const updatedAddButton = updatedSlide.querySelector('.slider-upsell__add-to-cart');

      const currentQuantityInput = currentSlide.querySelector('quantity-input');
      const currentAddButton = currentSlide.querySelector('.slider-upsell__add-to-cart');

      if (updatedQuantityInput && currentQuantityInput) {
        const isHidden = updatedQuantityInput.classList.contains('hidden');
        if (isHidden) {
          currentQuantityInput.classList.add('hidden');
        } else {
          currentQuantityInput.classList.remove('hidden');
        }

        const currentInput = currentQuantityInput.querySelector('input');
        const updatedInput = updatedQuantityInput.querySelector('input');
        if (currentInput && updatedInput) {
          currentInput.value = updatedInput.value;
        }
      }

      if (updatedAddButton && currentAddButton) {
        const isHidden = updatedAddButton.classList.contains('hidden');
        if (isHidden) {
          currentAddButton.classList.add('hidden');
        } else {
          currentAddButton.classList.remove('hidden');
        }
      }
    });

    this.quantitySelectors = this.querySelectorAll("quantity-input");
    this.quantitySelectors.forEach((qs) => {
      qs.removeEventListener("change", this.onQuantityChange);
      qs.addEventListener("change", this.onQuantityChange.bind(this));
    });

    if (this.swiperInstance) {
      this.swiperInstance.update();
    }
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  init() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
    this.swiperInstance = new Swiper(this.slider, {
      slidesPerView: 4,
      spaceBetween: 15,
      mousewheel: { invert: true },
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: ".slider-upsell__prev",
        nextEl: ".slider-upsell__next",
      },
      breakpoints: {
        0: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 4,
        },
      }
    });
  }
}
// Utility function to get the currently selected variant color
function getSelectedVariantColor() {
  const checkedVariant = document.querySelector('.variant-picker__selector input:checked');
  return checkedVariant ? checkedVariant.value : null;
}

// Run color filter on page load only if the selected variant value matches a color in the slider
document.addEventListener('DOMContentLoaded', () => {
  const selectedColor = getSelectedVariantColor();
  if (!selectedColor) return;

  const slider = document.querySelector('.color-type-variant');
  if (!slider) return;

  const colorOptions = [];
  slider.querySelectorAll('.color-type-slide').forEach(item => {
    const color = item.dataset.color?.toLowerCase().trim();
    if (color) colorOptions.push(color);
  });

  if (colorOptions.includes(selectedColor.toLowerCase().trim())) {
    console.log('[Page Load] Applying color filter for:', selectedColor);
    switchUpsellByColor(selectedColor);
  } else {
    console.log('[Page Load] Selected variant "' + selectedColor + '" is not a color option — skipping filter, all items visible');
  }
});

// Also run on variant change (already in your code)
document.addEventListener('click', function (event) {
  if (event.target.matches('.variant-picker__selector input')) {
    const selectedVariant = event.target.value;
    const slider = document.querySelector('.color-type-variant');
    let colorOptions = [];
    if (slider) {
      slider.querySelectorAll('.color-type-slide').forEach(item => {
        const color = item.dataset.color?.toLowerCase().trim();
        if (color) colorOptions.push(color);
      });
    }

    if (colorOptions.includes(selectedVariant.toLowerCase())) {
      switchUpsellByColor(selectedVariant);
    } else {
      console.log('[Variant Change] Selected variant has no matching color, slider remains unchanged.');
    }
  }
});


customElements.define("slider-upsell", SliderUpsell);
function switchUpsellModule(module) {
  let variant;
  if (!module) {
    variant = document.querySelector('.variant-picker__selector input:checked');
  } else {
    variant = module;
  }
  let variantName = variant.value.split("(")[0].trim().toLowerCase();

  document.querySelectorAll('.slider-upsell__item').forEach((upsell) => {
    upsell.classList.toggle('hidden', upsell.dataset.variant.toLowerCase() !== variantName);
  });
}
document.addEventListener('click', function (event) {
  if (event.target.matches('.variant-picker__selector input')) {
    if (document.querySelector('.variant-toggle')) {
      switchUpsellModule(event.target)
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.variant-toggle')) {
    switchUpsellModule();
  }
});

function setActiveSwatch(swatchElement) {
  if (!swatchElement) return;

  const currentAddonSwatchesContainer = swatchElement.closest('.addon-swatches');
  if (currentAddonSwatchesContainer) {
    currentAddonSwatchesContainer.querySelectorAll('.addon-swatch').forEach(s => {
      const pTag = s.closest('p');
      if (pTag) {
        pTag.classList.remove('active');
      }
    });
  }

  const clickedPTag = swatchElement.closest('p');
  if (clickedPTag) {
    clickedPTag.classList.add('active');
  }
}


function bindAddonSwatchClicks() {
  document.querySelectorAll(".addon-swatch").forEach(function (swatch) {
    swatch.removeEventListener("click", handleAddonSwatchClick);
    swatch.addEventListener("click", handleAddonSwatchClick);
  });
}

function handleAddonSwatchClick(event) {
  const swatch = event.currentTarget;
  const variantId = swatch.dataset.variantId;
  const parentSelector = swatch.dataset.parent;
  const parent = document.querySelector(parentSelector);
  const variantContainer = parent.closest(".slider-upsell__item-card");
  const variantHtmlContainer = variantContainer.querySelector(`.addon-variant-html[data-variant-id="${variantId}"]`);

  if (!variantHtmlContainer) return;

  setActiveSwatch(swatch);

  parent.innerHTML = variantHtmlContainer.innerHTML;

  const productForm = parent.querySelector("product-form");
  if (productForm) {
    const customEvent = new CustomEvent('product:form:mount', { detail: { form: productForm } });
    document.dispatchEvent(customEvent);
  }

  if (typeof window.theme !== 'undefined' && typeof window.theme.initProductForms === 'function') {
    window.theme.initProductForms();
  }

  bindAddonSwatchClicks();

  const newSwatchInRenderedContent = parent.querySelector(`.addon-swatch[data-variant-id="${variantId}"]`);
  setActiveSwatch(newSwatchInRenderedContent);
}


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".slider-upsell__item-card").forEach(function (upsellItem) {
    const firstSwatch = upsellItem.querySelector(".addon-swatch");
    if (firstSwatch) {
      const variantId = firstSwatch.dataset.variantId;
      const parentSelector = firstSwatch.dataset.parent;
      const parent = document.querySelector(parentSelector);
      const variantHtmlContainer = upsellItem.querySelector(`.addon-variant-html[data-variant-id="${variantId}"]`);

      if (variantHtmlContainer && parent) {
        parent.innerHTML = variantHtmlContainer.innerHTML;

        const currentDisplayedSwatch = parent.querySelector(`.addon-swatch[data-variant-id="${variantId}"]`);
        setActiveSwatch(currentDisplayedSwatch);

        const productForm = parent.querySelector("product-form");
        if (productForm) {
          const event = new CustomEvent('product:form:mount', { detail: { form: productForm } });
          document.dispatchEvent(event);
        }

        if (typeof window.theme !== 'undefined' && typeof window.theme.initProductForms === 'function') {
          window.theme.initProductForms();
        }
      }
    }
  });

  bindAddonSwatchClicks();
});

function switchProductCards(selectedSize) {
  const size = selectedSize.toLowerCase().trim();

  document.querySelectorAll('.slider-upsell__item-card').forEach(card => {
    const cardSize = card.dataset.size?.toLowerCase().trim();
    const hide = cardSize !== size;
    card.classList.toggle('hidden', hide);
  });
}
function switchUpsellByColor(selectedColor) {
  const color = selectedColor.toLowerCase().trim();
  console.log('[Color Filter] Selected color:', color);

  const slider = document.querySelector('.color-type-variant');
  if (!slider) {
    console.warn('[Color Filter] No <slider-upsell> element found!');
    return;
  }

  const items = slider.querySelectorAll('.color-type-slide');
  let visibleCount = 0;

  items.forEach((item, index) => {
    const itemColor = item.dataset.color?.toLowerCase().trim();
    const hide = itemColor !== color;
    // if (currentProductHandle == 'eclipse-sofa') {
    item.classList.toggle('hidden', hide);
    // }
    if (!hide) visibleCount++;
    console.log(`[Color Filter] Item ${index}: color=${itemColor}, hide=${hide}`);
  });

  console.log(`[Color Filter] Total visible items: ${visibleCount}`);

  // Update Swiper if exists
  const swiperEl = slider.querySelector('.color-type-swiper');
  if (swiperEl && swiperEl.swiper) {
    console.log('[Color Filter] Updating Swiper...');
    swiperEl.swiper.update();
  }
}

// Example: trigger on variant change
// document.addEventListener('click', function(event) {
//   if (event.target.matches('.variant-picker__selector input')) {
//     const selectedVariant = event.target.value; // adjust if your color is in option1
//     console.log('[Variant Change] Detected new variant:', selectedVariant);
//     switchUpsellByColor(selectedVariant);
//   }
// });



function bindVariantEvents() {
  const container = document.querySelector('.variant-picker__selector');
  if (!container) {
    console.warn('No variant picker container found to bind events.');
    return;
  }

  container.querySelectorAll('input[type="radio"]').forEach(input => {
    input.removeEventListener('change', onVariantChange);
    input.addEventListener('change', onVariantChange);
  });

  const checked = container.querySelector('input[type="radio"]:checked');
  if (checked) {
    switchProductCards(checked.value);
    setupSingleUpsellSizeLogic(checked.value);
  }
}

function onVariantChange(e) {
  switchProductCards(e.target.value);
  setupSingleUpsellSizeLogic(e.target.value);
}

function observeVariantChanges() {
  const productFormContainer = document.querySelector('form[action^="/cart/add"]')?.closest('section') || document.body;

  const observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
      if ([...mutation.addedNodes].some(node =>
        node.nodeType === 1 &&
        node.querySelector &&
        node.querySelector('.variant-picker__selector')
      )) {
        bindVariantEvents();
        break;
      }
    }
  });

  observer.observe(productFormContainer, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  bindVariantEvents();
  observeVariantChanges();
});

function setupSingleUpsellSizeLogic(selectedSize) {
  const baseSize = selectedSize.toLowerCase().split('(')[0].trim();

  document.querySelectorAll('.slider-single-upsell__item').forEach(item => {
    const itemSize = item.dataset.size?.toLowerCase().split('(')[0].trim();
    const hide = itemSize !== baseSize;
    item.classList.toggle('hidden', hide);
  });
}
function toggleSingleUpsells() {
  if (typeof window.currentProductHandle === 'undefined' || window.currentProductHandle !== 'delve-bed-frame') return;
  document.querySelectorAll('.single-upsell-dbf').forEach(container => {
    const itemsContainer = container.querySelector('.single-upsell-items-dbf');
    if (!itemsContainer) return;

    const items = itemsContainer.querySelectorAll('.single-upsell-item-dbf');
    if (!items.length) return;

    const allHidden = Array.from(items).every(item => item.classList.contains('hidden'));

    container.style.display = allHidden ? 'none' : '';
  });
}

document.addEventListener('DOMContentLoaded', toggleSingleUpsells);

document.addEventListener('variant-change', toggleSingleUpsells);

if (typeof window.currentProductHandle === 'undefined' || window.currentProductHandle == 'delve-bed-frame') {
  const observer = new MutationObserver(toggleSingleUpsells);
  document.querySelectorAll('.single-upsell-items-dbf').forEach(el => {
    observer.observe(el, { childList: true, subtree: true, attributes: true });
  });
}

